module.exports = __webpack_public_path__ + "img/vaccination-sch.b4c84bed.svg";